import React, { createContext, useReducer } from "react";
import AppReducer from "./AppReducer";

import defaultProfile1 from "../data/defaults/profile_p1.json";
import defaultProfile2 from "../data/defaults/profile_p2.json";
import defaultMods from "../data/defaults/mods.json";

const initialState = {
    language: "en",
    userData: {
        profile_p1: defaultProfile1,
        profile_p2: defaultProfile2,
        mods: defaultMods,
        record_enso_p1: [],
        record_enso_p2: [],
        record_ai_battle: [],
    },
};

export const GlobalContext = createContext(initialState);

export const GlobalProvider = ({ children }) => {
    const [state, dispatch] = useReducer(AppReducer, initialState);

    const setDefaultUserData = () => {
        dispatch({
            type: "SET_USERDATA",
            payload: initialState.userData,
        });
    };

    const setAllUserData = (payload) => {
        dispatch({ type: "SET_USERDATA", payload });
    };

    const setMods = (mods) => {
        dispatch({
            type: "SET_MODS",
            payload: mods,
        });
    };

    const setProfile = (profile, player) => {
        if (player === 1) {
            dispatch({
                type: "SET_PROFILE_P1",
                payload: profile,
            });
        } else if (player === 2) {
            dispatch({
                type: "SET_PROFILE_P2",
                payload: profile,
            });
        }
    };

    const setRecordEnso = (record, player) => {
        if (player === 1) {
            dispatch({
                type: "SET_RECORD_ENSO_P1",
                payload: record,
            });
        } else if (player === 2) {
            dispatch({
                type: "SET_RECORD_ENSO_P2",
                payload: record,
            });
        }
    };

    const setRecordAi = (record) => {
        dispatch({
            type: "SET_RECORD_AI",
            payload: record,
        });
    };

    const setLanguage = (language) => {
        dispatch({
            type: "SET_LANGUAGE",
            payload: language,
        });
    };

    // console.log("global state: ", state);

    return (
        <GlobalContext.Provider
            value={{
                ...state,
                setDefaultUserData,
                setAllUserData,
                setMods,
                setProfile,
                setRecordEnso,
                setRecordAi,
                setLanguage,
            }}
        >
            {children}
        </GlobalContext.Provider>
    );
};
